import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Search, Home } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-125">
      {/* Background Image with Parallax-like fixed position */}
      <div className="absolute inset-0 bg-hero-pattern bg-cover bg-center bg-fixed bg-no-repeat" role="img" aria-label="Luxury Arizona desert home" data-id="element-126" />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80" data-id="element-127" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center text-white" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-129">
          <h2 className="text-brand-gold font-medium tracking-[0.2em] uppercase mb-4 text-sm md:text-base" data-id="element-130">
            Arizona Real Estate Agent
          </h2>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading leading-tight mb-6" data-id="element-131">
            Curating Homes. <br data-id="element-132" />
            Delivering Peace of Mind.
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto mb-10 font-light" data-id="element-133">
            Specializing in on & off-market housing in Gilbert, Scottsdale, and
            the greater Phoenix valley.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-134">
            <Button size="lg" className="w-full sm:w-auto min-w-[200px]" data-id="element-135">
              <Search className="mr-2 h-5 w-5" data-id="element-136" />
              Search Homes
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto min-w-[200px]" data-id="element-137">
              <Home className="mr-2 h-5 w-5" data-id="element-138" />
              Get Home Valuation
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" initial={{
      opacity: 0
    }} animate={{
      opacity: 1,
      y: [0, 10, 0]
    }} transition={{
      delay: 1,
      duration: 2,
      repeat: Infinity
    }} data-id="element-139">
        <div className="w-[1px] h-16 bg-gradient-to-b from-white to-transparent" data-id="element-140"></div>
      </motion.div>
    </section>;
}